import { render } from "./App.vue?vue&type=template&id=3479629c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3479629c&lang=scss"

import exportComponent from "E:\\code\\libra-3rd\\yuexinting-jiading\\yxt-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__